// Co-Authored-By: AI-Assisted | updated: 2026-10-29 00:00:00
import md5 from 'js-md5';
import { guid } from '@/utils/uuid';
import { getDeviceId } from '@/utils/device';
import { queryString } from '@/utils/url';
import { APPID, SIGN_KEY as KEY } from '@/origin';

export const AUTH_PARAM_KEYS = ['appid', 'format', 'requestid', 'sign_method', 'timestamp', 'v', 'sign'];

//组合参数并排序 格式化参数
function formatParams(params = {}) {
  return Reflect.ownKeys(params).sort().reduce((Accumulator, Current) => ({ ...Accumulator, [Current]: params[Current] }), {});
}

// 获取开放平台鉴权参数（不涉及任何业务数据）
function getOpenAuthParams() {
  return {
    appid: APPID,
    format: 'json',
    v: '2.0',
    sign_method: 'md5',
    requestid: `${getDeviceId()}_${guid()}`,
    timestamp: Math.floor(Date.now() / 1000)
  };
}

// 签名计算（仅基于开放平台鉴权参数，不涉及任何业务数据）
function computeSign(authParams) {
  const sorted = formatParams(authParams);
  return md5(`${queryString(sorted)}&key=${KEY}`).toUpperCase();
}

// 通过md5签名加密
// externalAuth 为外部鉴权参数（免密登录等场景），传入时外部签名优先，不传时自动计算 sign
export function md5sign(params = {}, externalAuth) {
  const generated = getOpenAuthParams();
  if (externalAuth) {
    return { ...params, ...generated, ...externalAuth };
  }
  return { ...params, ...generated, sign: computeSign(generated) };
}

// 签名字符串（raw fetch 用）
export function getSignedQuery(options = {}) {
  const { params = {}, baseUrl } = options;
  const qs = queryString(md5sign(params));
  if (!baseUrl) return qs;
  return `${baseUrl}?${qs}`;
}